// 售后订单的一些常量


export const All_After_Sale = {
  value: 0, 
  EnglishName: 'allaftersale',
  name: '全部',
}

export const Seller_Wait_Deal = {
  value: 10, 
  EnglishName: 'sellerWaitDeal',
  name: '待商家处理',
}

export const Wait_Returning = {
  value: 20, 
  EnglishName: 'waitReturning',
  name: '退款中',
}

export const Buyer_Wait_Deal = {
  value: 30, 
  EnglishName: 'buyerWaitDeal',
  name: '拒绝售后申请',
}

export const Wait_Buyer_Post = {
  value: 40, 
  EnglishName: 'waitBuyerPost',
  name: '待买家退货',
}

export const Buyer_Already_Post = {
  value: 41, 
  EnglishName: 'waitBuyerPost',
  name: '待商家收货',
}

export const Platform_Dealing = {
  value: 50, 
  EnglishName: 'platformDealing',
  name: '平台处理中',
}
//refundClose
export const Refund_Fail = {
  value: 60, 
  EnglishName: 'refund_fail',
  name: '退款失败',
}

export const Refund_Success = {
  value: 70, 
  EnglishName: 'refund_success',
  name: '退款成功',
}

export const Refund_Close = {
  value: 80, 
  EnglishName: 'refund_close',
  name: '退款关闭',
}

export const After_Sale_List = [
  All_After_Sale,
  Seller_Wait_Deal,
  Wait_Buyer_Post,
  Buyer_Already_Post,
  Buyer_Wait_Deal,
  Platform_Dealing,
  Refund_Fail,
  Refund_Success,
  Refund_Close
]


//上游售后状态
export const Target_Order_After_Sales_Not_Apply = {
  name: '未申请或已完成',
  value: 10
}

export const Target_Order_After_Sales_Apply = {
  name: '已申请',
  value: 20
}

export const Target_Order_After_Sales_Wait_Return_Goods = {
  name: '待退货',
  value: 30
}

export const Target_Order_After_Sales_Already_Return_Goods = {
  name: '已退回',
  value: 40
}

export const Target_Order_After_Sales_Refuse = {
  name: '被拒绝',
  value: 50
}

export const Target_Order_After_Sales_Close = {
  name: '已关闭',
  value: 60
}

export const Target_Order_After_Sales_Refund_Success = {
  name: '退款成功',
  value: 70
}

export const Target_Order_After_Sales = [
  Target_Order_After_Sales_Apply,
  Target_Order_After_Sales_Wait_Return_Goods,
  Target_Order_After_Sales_Already_Return_Goods,
  Target_Order_After_Sales_Refuse,
  Target_Order_After_Sales_Close,
  Target_Order_After_Sales_Refund_Success,
  Target_Order_After_Sales_Not_Apply
]



export const After_Sales_Refund_Goods_Type = {
  name: '退货退款',
  value: 2,
  color:'#2db7f5'
}

export const After_Sales_Only_Refund_Type = {
  name: '已发货仅退款',
  value: 1,
  color:'#108ee9'
}

export const After_Sales_Before_Send_Only_Refund_Type = {
  name: '未发货仅退款',
  value: 1,
  color:'#2db7f5'
}


export const After_Sales_Replace_Goods_Type = {
  name: '换货',
  value: 3,
  color:'#87d068'
}

// export const After_Sales_System_Cancel = {
//   name: '系统取消',
//   value: 4,
//   color:'red'
// }

// export const After_Sales_User_Cancel = {
//   name: '用户取消',
//   value: 5,
//   color:'red'
// }

export const After_Sales_Keep_price ={
  name:'价保',
  value: 6,
  color:'orange'
}
export const After_Sales_Add_Post_Type = {
  name: '补寄',
  value: 4,
  color:'#f50'
}

export const After_Sales_Repair_Type = {
  name: '维修',
  value: 5,
  color:'orange'
}

//售后类型
export const After_Sales_Types = [
  After_Sales_Refund_Goods_Type,
  After_Sales_Only_Refund_Type,
  After_Sales_Before_Send_Only_Refund_Type,
  After_Sales_Replace_Goods_Type,
  // After_Sales_System_Cancel,
  // After_Sales_User_Cancel,
  After_Sales_Keep_price,
  After_Sales_Add_Post_Type,
  After_Sales_Repair_Type
]


export const DyOrders_OrderStatus = {
  //待发货
  waitSend: 1, 
  //已发货
  alreadySend: 2,
  //已关闭
  isFinish: 3
}